<template>
  <div :class="'custom-button ' + active">
    <img class="icon" :class="buttonIcon">
    <div class="button-text" :class="buttonColour" :style="{ minWidth: minWidth }">
      <h2 style="padding-top: 0.1em;">{{ buttonTitle }}</h2>
    </div>
  </div>
</template>

<script>
export default { 
  name: "CustomButton",
  props: {
    buttonTitle: String,
    buttonIcon: String,
    buttonColour: String,
    minWidth: { type: String, default: '160px' },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    active() {
      if (this.disabled) {
        return "disabled"
      }
    }
  }
};
</script>

<style scoped>
.custom-button {
  display: flex;
  position: relative;
  width: fit-content;
  height: 4em;
  margin: 0.5em auto;
  border-radius: 0.25em;
  color: var(--warm-sandstone);
  background-color: var(--light-charcoal);
  cursor: pointer;
  transition: 0.1s;
}
.custom-button.disabled {
  opacity: 0.35;
  pointer-events: none;
}
.button-text {
  display: flex;
  min-width: 160px;
  justify-content: center;
  align-items: center;
  padding: 0 0.5em;
  border-radius: 0.25em;
  color: var(--warm-sandstone);
  transition: 0.1s;
}
.custom-button:hover {
  color: var(--charcoal);
  .button-text {
    color: var(--charcoal);
    background-color: var(--warm-sandstone);
  }
}


.red {
  background-color: var(--brick);
  mask: url(../assets/texture_1.png) 0 0/22em 3em;
}
.grey {
  background-color: var(--grey);
  mask: url(../assets/texture_2.png) 0 0/22em 3em;
}
.blue {
  background-color: var(--blue);
  mask: url(../assets/texture_3.png) 0 0/22em 3em;
}
  @media (max-width: 500px) {
    .custom-button {
      font-size: .8em; 
        width: 13.5em;
        
      }
      .custom-button h2{
      font-size: 1.7em; 
        
      }
      .button-text{
      width: 100%;
      }
  }
</style>